/* eslint-disable */

import { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { useBusinessDataQuery } from '@/hooks/business/useBusinessDataQuery'
import { useBusinessPackagesQuery } from '@/hooks/business/useBusinessPackagesQuery'

import useServer from '../../../api/useServerMain'
import DateInput from '../../../components/forms/DateInput'
import Check from '../../../components/forms/GenericCheck'
import Input from '../../../components/forms/Input'
import Toggle from '../../../components/forms/Toggle'
import Button from '../../../components/misc/Button'
import GenericTable, {
  DataTableInterface,
} from '../../../components/misc/GenericTable'
import GenericToggle from '../../../components/misc/GenericToggle'
import { useAppSelector } from '../../../store/hooks'
import { translateMeasure } from '../../../utils/translate'
import { DetailProductContext } from '../DetailProductContainer'

//View for case STOCK, RAW, MANUFACTURED, WASTE, ASSET ---------------------------------------------
const Contable = () => {
  const { denyRoles } = useServer()
  const { business } = useAppSelector((state) => state.init)

  const reserve_products_with_prebilling =
    business?.configurationsKey.find(
      (itm) => itm.key === 'reserve_products_with_prebilling'
    )?.value === 'true'
  const { product, updateProduct, limitProductArea, updateLimitProductArea } =
    useContext(DetailProductContext)
  const [alertLimit, setAlertLimit] = useState(!!product?.alertLimit)
  const { control, handleSubmit, setValue, watch, getValues } = useForm()
  const onSubmit: SubmitHandler<Record<string, string | number>> = (data) => {
    if (updateProduct)
      updateProduct(product?.id, {
        ...data,
        alertLimit: alertLimit ? 1 : null,
      })
    const areaLimits = getValues('alertLimit')
    product?.stockAreaProducts?.forEach((item, index) => {
      if (areaLimits?.[index] && areaLimits[index] !== '')
        updateLimitProductArea?.({
          productId: product.id,
          areaId: item.area.id as number,
          amount: areaLimits[index],
        })
    })
  }

  //Table data ------------------------------------------
  const quantityByGroup: (_quantity: number) => string | void = (quantity) => {
    if (product?.enableGroup) {
      const rest = quantity % (product.groupConvertion ?? 1)
      return `${Math.trunc(quantity / (product.groupConvertion ?? 1))} ${product.groupName ?? ''} ${
        rest !== 0 ? '(+' + rest + translateMeasure(product.measure) + ')' : ''
      }`
    }
  }
  const tableTitles = ['Almacén', 'Cantidad', 'Reservado']
  if (!reserve_products_with_prebilling)
    tableTitles.filter((item) => item !== 'Reservado')
  if (alertLimit) tableTitles.push('Límite de alerta')
  if (product?.enableGroup) tableTitles.push('Agrupación')
  const tableData: DataTableInterface[] = []
  product?.stockAreaProducts?.forEach((item, index) => {
    tableData.push({
      payload: {
        Almacén: item.area.name,
        Cantidad: <p className="font-semibold">{Number(item.quantity)}</p>,
        Reservado: <p className="font-semibold">{Number(item.reserved)}</p>,
        Agrupación: quantityByGroup(item.quantity) ?? '',
        'Límite de alerta': (
          <div className={'flex items-center justify-center'}>
            <div className={'w-16'}>
              <Input
                control={control}
                defaultValue={
                  limitProductArea?.find((i) => i.areaId === item?.area?.id)
                    ?.amount ?? ''
                }
                name={`alertLimit.${index}`}
                type="number"
              />
            </div>
          </div>
        ),
      },
    })
    if (item.variations.length !== 0) {
      item.variations.forEach((variation) =>
        tableData.push({
          payload: {
            Almacén: (
              <p className="pl-5 font-normal">{variation.variation.name}</p>
            ),
            Cantidad: variation.quantity,
          },
        })
      )
    }
  })

  //--------------------------------------------------------------------

  useEffect(() => {
    if (!alertLimit) setValue('alertLimit', null)
  }, [alertLimit])

  return (
    <form
      className="flex flex-col justify-between"
      onSubmit={handleSubmit(onSubmit)}
    >
      <section className="relative grid grid-cols-10 gap-10">
        <div className="col-span-4 place-items-start overflow-scroll pt-5 scrollbar-thin">
          <div>
            <h4 className="font-semibold">Cantidad Total:</h4>
            <p className="mr-10 text-gray-700">
              {product?.totalQuantity +
                ' ' +
                translateMeasure(product?.measure)}
            </p>
          </div>
          <form
            className="flex flex-col gap-y-2 p-1"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className={'mb-5'}>
              <GenericToggle
                changeState={setAlertLimit}
                currentState={alertLimit}
                title="Límite de alerta"
              />
              <div className={`ms-5 ${alertLimit ? 'visible' : 'invisible'}`}>
                <Toggle
                  control={control}
                  defaultValue={!!product?.isAlertable}
                  name="isAlertable"
                  title="Habilitar notificación"
                />
              </div>
            </div>

            <Toggle
              control={control}
              defaultValue={!!product?.enableGroup}
              name="enableGroup"
              title="Habilitar agrupación"
            />

            {(watch('enableGroup') ?? product?.enableGroup) && (
              <>
                <Input
                  control={control}
                  defaultValue={product?.groupName}
                  label="Nombre de la agrupación"
                  name="groupName"
                  rules={{ required: 'Este campo es requerido' }}
                />
                <Input
                  control={control}
                  defaultValue={product?.groupConvertion}
                  label="Agrupar en conjuntos de"
                  name="groupConvertion"
                  rules={{ required: 'Este campo es requerido' }}
                />
              </>
            )}
          </form>
        </div>
        {tableData.length !== 0 && (
          <div className="col-span-6 h-full overflow-auto scrollbar-thin scrollbar-thumb-gray-300">
            <GenericTable tableData={tableData} tableTitles={tableTitles} />
          </div>
        )}
      </section>
      {denyRoles(['AUDITOR']) && (
        <div className="fixed bottom-16 right-5 flex items-center justify-end pt-3">
          <Button color="slate-600" name="Actualizar" type="submit" />
        </div>
      )}
    </form>
  )
}
//------------------------------------------------------------------------------------------------------
//Component for MENU,ADDON,SERVICE,COMBO ---------------------------------------------------------------
const NoContable = () => {
  const { denyRoles } = useServer()

  const { product, updateProduct, updateStockProductState } =
    useContext(DetailProductContext)
  const { control, handleSubmit, watch, setValue, clearErrors } = useForm()
  const onSubmit: SubmitHandler<Record<string, string | number>> = (data) =>
    updateProduct && updateProduct(product?.id, data, updateStockProductState)
  const { businessData, isLoadingBusinessData, isErrorBusinessData } =
    useBusinessDataQuery({})
  const { businessPackages } = useBusinessPackagesQuery({
    params: { businessId: businessData?.id ?? 0 },
    options: {
      enabled:
        !!businessData?.id && !isLoadingBusinessData && !isErrorBusinessData,
    },
  })
  const availableForReservation =
    watch('availableForReservation') ?? product?.availableForReservation

  const [alwaysAvailableForReservation, setAlwaysAvailableForReservation] =
    useState(product?.alwaysAvailableForReservation)

  useEffect(() => {
    setValue('reservationAvailableFrom', undefined)
    setValue('reservationAvailableTo', undefined)
  }, [watch('availableForReservation'), alwaysAvailableForReservation])

  useEffect(() => {
    setValue('alwaysAvailableForReservation', false)
  }, [availableForReservation])

  const reservationAvailableFrom =
    watch('reservationAvailableFrom') ?? product?.reservationAvailableFrom
  const reservationAvailableTo =
    watch('reservationAvailableTo') ?? product?.reservationAvailableTo

  return (
    <div className="p-6">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid w-full grid-cols-2">
          {/* Col 1 */}
          <div className="flex flex-col">
            <Input
              control={control}
              defaultValue={product?.totalQuantity}
              disabled={product?.type === 'COMBO'}
              label={`Cantidad Total (${translateMeasure(product?.measure)})`}
              name="totalQuantity"
              rules={{ required: 'Este campo es requerido' }}
              type="number"
            />

            {product?.type === 'COMBO' && product.compositions.length !== 0 && (
              <div className="text-sm font-semibold text-gray-600">
                *La disponibilidad se calculará automáticamente por la
                disponibilidad de sus compuestos
              </div>
            )}

            <div className={'mt-5'}>
              <Toggle
                control={control}
                defaultValue={product?.stockLimit}
                name="stockLimit"
                title="Limitar cantidad disponible"
              />
              <div className="inline-flex gap-5">
                {(watch('stockLimit') ?? product?.stockLimit) && (
                  <div className="ms-5 flex flex-col space-y-2">
                    <Input
                      control={control}
                      defaultValue={product?.alertLimit}
                      label="Límite de alerta"
                      name="alertLimit"
                      type="number"
                    />

                    <Toggle
                      control={control}
                      defaultValue={!!product?.isAlertable}
                      name="isAlertable"
                      title="Habilitar notificación"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Col 2 */}
          {product?.type === 'SERVICE' &&
            // business?.configurationsKey.find(
            //   (itm) => itm.key === 'module_booking'
            // )?.value === 'true'
            businessPackages?.find((itm) => itm.code === 'M_BOOKING')
              ?.isActive && (
              <div className="flex flex-col items-start justify-center gap-y-3">
                <Toggle
                  control={control}
                  defaultValue={product?.availableForReservation}
                  name="availableForReservation"
                  title="Disponibilidad para Reservar"
                />

                {availableForReservation && (
                  <>
                    <div className="ml-2">
                      <Check
                        checked={alwaysAvailableForReservation}
                        label="Siempre"
                        onChange={() => {
                          setValue(
                            'alwaysAvailableForReservation',
                            !alwaysAvailableForReservation
                          )
                          setAlwaysAvailableForReservation(
                            !alwaysAvailableForReservation
                          )
                        }}
                        value={''}
                      />
                    </div>

                    <div className="flex gap-x-4">
                      {!alwaysAvailableForReservation && (
                        <DateInput
                          control={control}
                          defaultValue={product?.reservationAvailableFrom}
                          disabled={watch('alwaysAvailableForReservation')}
                          label="Fecha inicio"
                          name="reservationAvailableFrom"
                          rules={{ required: 'Este campo es requerido' }}
                        />
                      )}
                      {!alwaysAvailableForReservation && (
                        <DateInput
                          control={control}
                          defaultValue={reservationAvailableTo}
                          disabled={
                            alwaysAvailableForReservation ||
                            !reservationAvailableFrom
                          }
                          fromCustom={reservationAvailableFrom}
                          label="Fecha fin"
                          name="reservationAvailableTo"
                          rules={{
                            validate: () => {
                              return (
                                reservationAvailableTo >
                                  reservationAvailableFrom ||
                                'La fecha de finalización debe ser posterior a la fecha de inicio'
                              )
                            },
                            onChange: () => {
                              clearErrors('reservationAvailableTo')
                            },
                          }}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
        </div>
        <div>
          {denyRoles(['AUDITOR']) && (
            <div className="flex items-center justify-end pt-20">
              <Button color="slate-600" name="Actualizar" type="submit" />
            </div>
          )}
        </div>
      </form>
    </div>
  )
}
//-------------------------------------------------------------------------------------------------------
const Disponibility = () => {
  const { product } = useContext(DetailProductContext)

  return (
    <div className="h-[34rem] rounded-md border border-slate-300 p-5">
      {[
        'STOCK',
        'RAW',
        'MANUFACTURED',
        'WASTE',
        'ASSET',
        'VARIATION',
        'INPUT',
      ].includes(product?.type ?? '') ? (
        <Contable />
      ) : (
        <NoContable />
      )}
    </div>
  )
}

export default Disponibility
